import { render, staticRenderFns } from "./carEvent.vue?vue&type=template&id=dec17714&"
import script from "./carEvent.vue?vue&type=script&lang=js&"
export * from "./carEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports